import { createBasicSelector } from 'util/redux'
import { selectPreferences } from './selectPreferences'

export const selectNpsNextTimestamp = createBasicSelector(
  selectPreferences,
  preferences => {
    return preferences.nps_next_timestamp || null
  }
)
